function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createModel } from '@rematch/core';
// 暂时无用，等需要的时候再考虑改好
var DEFUALT_LOGO = 'esghub-logo-blghkg.svg';
var DEFAULT_LOGO_BLACK = 'user-esghub-logo-f3497f.svg';
/**
 * 微前端主站传递给子站数据的 modal 创建方法，用于主站和子站定义对应的 rematch model
 * @returns function 返回一个方法，方法需要指定各自项目 model 的类型，调用后得到 mainApp model
 */
export function createMainAppModal() {
  return createModel()({
    state: {
      userInfo: {},
      // 暂时无用，等需要的时候再考虑改好
      initializeConfig: {
        isSSOEnable: false,
        loginMessage: '',
        loginImage: '',
        esghubLogo: DEFUALT_LOGO,
        esghubLogoBlack: DEFAULT_LOGO_BLACK
      }
    },
    reducers: {
      // 供主站调用，更新 user service who am i 数据
      updateWhoAmi: function updateWhoAmi(state, payload) {
        return _objectSpread(_objectSpread({}, state), {}, {
          userInfo: _objectSpread(_objectSpread({}, state.userInfo), {}, {
            languageCache: payload.preference.language
          }, payload)
        });
      },
      // 供主站调用，更新 ehs who am i 数据
      updateInternalWhoAmi: function updateInternalWhoAmi(state, payload) {
        // webfunny 用的，暂时不需要了
        localStorage.setItem('wmUserInfo', JSON.stringify({
          userId: payload.companyId,
          userTag: payload.companyName,
          projectVersion: '2022-05-29'
        }));
        return _objectSpread(_objectSpread({}, state), {}, {
          userInfo: _objectSpread(_objectSpread({}, state.userInfo), {}, {
            internalWhoAmi: payload
          })
        });
      },
      // 供主站调用，更新语言
      updateLanguageCache: function updateLanguageCache(state, payload) {
        return _objectSpread(_objectSpread({}, state), {}, {
          userInfo: _objectSpread(_objectSpread({}, state.userInfo), {}, {
            languageCache: payload
          })
        });
      },
      // 供子站调用，更新所有数据
      updateMainApp: function updateMainApp(state, payload) {
        return _objectSpread(_objectSpread({}, state), payload);
      }
    }
  });
}

// 为了定义 IRootModel 类型创建 mainApp，实际上没有用
var mainApp = createMainAppModal();